import Axios from '../lib/axios';

/**
 * Fetches manual and HD bonuses for the current user with pagination and filtering
 * @param params Object containing page, limit, date range, etc.
 */
const GetBonuses = (params?: any) => {
  return Axios.get(`${process.env.REACT_APP_SERVER_ROOT || ''}/bonuses`, { params });
};

/**
 * Fetches all users' bonuses for admin, with pagination, date range, and userId filtering
 * @param params Object containing page, limit, date range, userId, etc.
 */
const GetAdminBonuses = (params?: any) => {
  return Axios.get(`${process.env.REACT_APP_SERVER_ROOT || ''}/admin/bonuses`, { params });
};

const BonusService = {
  GetBonuses,
  GetAdminBonuses,
};

export default BonusService;
